import { render, staticRenderFns } from "./MemberInquiry.vue?vue&type=template&id=48712c57&scoped=true"
import script from "./MemberInquiry.vue?vue&type=script&lang=js"
export * from "./MemberInquiry.vue?vue&type=script&lang=js"
import style0 from "./MemberInquiry.vue?vue&type=style&index=0&id=48712c57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48712c57",
  null
  
)

export default component.exports